export default __webpack_public_path__ + "static/media/physical-therpy.09229adf.png";